import '@babel/polyfill';
import 'url-polyfill';
import { polyfill } from 'es6-promise';
polyfill();
import 'isomorphic-fetch';

import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import { clearAccessAndIdTokens, getTokens, saveTokens, clearTokens, getTokenSource, hasValidTokens } from './utils/oauthTokenStorage';
import { refreshTokens } from './api/oauthClient';

(function() {
    if (!window.CognitoRegion || !window.CognitoUserPoolId || !window.CognitoClientIdPlayfootball || !window.CRMHost) {
        console.warn('CognitoRegion, CognitoUserPoolId, CognitoClientIdPlayfootball, CRMHost is required');
        return;
    }

    if (window.OAuthConfig?.enabled) {
        // When the user navigates away or closes the tab, clear the short-lived
        // access and ID tokens. The refresh token is kept so retrieveCurrentUser()
        // can silently obtain fresh tokens on the next visit — no re-login required.
        window.addEventListener('beforeunload', clearAccessAndIdTokens);

        // When the user switches back to this tab, attempt a silent token refresh.
        // If another app called GlobalSignOut, the refresh token is revoked server-side
        // and the refresh will fail — triggering a full re-login via the auth guard.
        document.addEventListener('visibilitychange', async () => {
            if (document.visibilityState !== 'visible') return;
            const tokens = getTokens();
            if (!tokens) return;

            // Only attempt refresh when the access token has actually expired.
            if (hasValidTokens()) return;

            // SDK tokens were issued by auth-ui's Cognito client (VITE_COGNITO_CLIENT_ID),
            // not by KeeperFA's client (OAuthConfig.clientId / keeperfa-stg).
            // refreshTokensViaCognitoApi sends OAuthConfig.clientId, which Cognito rejects
            // with "Refresh Token does not match the ClientId" (400) for SDK-issued tokens.
            // We simply cannot refresh SDK tokens from KeeperFA's context — skip the attempt.
            // GlobalSignOut detection for SDK tokens happens naturally: when the access token
            // expires, retrieveCurrentUser() attempts refresh → fails → clears tokens → beforeEach
            // guard does prompt=none → auth-ui detects revoked session → login_required → login.
            const source = getTokenSource();
            if (source !== 'pkce') return;

            try {
                const response = await refreshTokens(tokens.refreshToken);

                saveTokens({
                    accessToken: response.access_token,
                    idToken: response.id_token,
                    refreshToken: response.refresh_token,
                });
            } catch {
                // Refresh token revoked (GlobalSignOut by another app) — clear all tokens
                // and redirect to home so the auth guard triggers a fresh login.
                clearTokens();
                window.location.href = '/';
            }
        });
    }

	if (!window.CognitoSignOutImageURIs) {
		window.CognitoSignOutImageURIs = [];
	}

	if (localStorage.ffaClientId) {
		window.CognitoClientIdPlayfootball = localStorage.ffaClientId;
	}

    new Vue({
        el: '#app',
        template: '<App/>',
        components: { App },
        store,
        router
    });
})();
